export default [
    {
        id: 1,
        name: 'pubref',
        value: 'pubref',
    },
    {
        id: 2,
        name: 'puboid',
        value: 'pubid',
    },
    {
        id: 3,
        name: 'affpubid',
        value: 'affpubid',
    },
    {
        id: 4,
        name: 'IOS IDFA',
        value: 'iosidfa',
    },
    {
        id: 5,
        name: 'Google AID',
        value: 'gclid',
    },
    {
        id: 6,
        name: 'Transaction Id',
        value: 'transactionid',
    },
    {
        id: 7,
        name: 'Country Code',
        value: 'country',
    },
    {
        id: 8,
        name: 'Handset Language',
        value: 'language',
    },
    {
        id: 9,
        name: 'OS',
        value: 'device_os',
    },
    {
        id: 10,
        name: 'Form Factor',
        value: 'device_type',
    },
    {
        id: 11,
        name: 'subid1',
        value: 'subid1',
    },
    {
        id: 12,
        name: 'subid2',
        value: 'subid2',
    },
    {
        id: 13,
        name: 'subid3',
        value: 'subid3',
    },
    {
        id: 14,
        name: 'subid4',
        value: 'subid4',
    },
    {
        id: 15,
        name: 'subid5',
        value: 'subid5',
    },
];